import styled from 'styled-components';
import {
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid ${token('colors.gray300')};
    border-top: 1px solid ${token('colors.gray300')};
    padding: ${spaceMixin('md')} 0px;
    margin-bottom: ${spaceMixin('xs')};
`;
